// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var Substitution$ReactHooksTemplate = require("../common/Substitution.res.js");
var MultipleSelect$ReactHooksTemplate = require("./MultipleSelect.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var MandatoryMessage$ReactHooksTemplate = require("./MandatoryMessage.res.js");
var MultipleSelectOptions$ReactHooksTemplate = require("./MultipleSelectOptions.res.js");

function MultipleSelectDefaultForm(props) {
  var substitutionVariables = props.substitutionVariables;
  var onChange = props.onChange;
  var mandatory = props.mandatory;
  var language = props.language;
  var multipleSelect = props.multipleSelect;
  var match = React.useState(function (param) {
        
      });
  var setErrorMessage = match[1];
  var errorMessage = match[0];
  var rawText = MultipleSelect$ReactHooksTemplate.getTextTranslation(multipleSelect, SurveyLanguage$ReactHooksTemplate.name(language));
  var rawDescription = MultipleSelect$ReactHooksTemplate.getDescriptionTranslation(multipleSelect, SurveyLanguage$ReactHooksTemplate.name(language));
  var titleHtml = Substitution$ReactHooksTemplate.renderQuestionText(rawText, substitutionVariables) + (
    mandatory ? " *" : ""
  );
  var descriptionHtml = Substitution$ReactHooksTemplate.renderQuestionText(rawDescription, substitutionVariables);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              className: "survey-rich-text text-lg font-medium text-darkcharcoal py-6 whitespace-pre-line",
                              dangerouslySetInnerHTML: {
                                __html: titleHtml
                              }
                            }),
                        JsxRuntime.jsx("div", {
                              className: "survey-rich-text text-base font-normal text-darkcharcoal pb-8 whitespace-pre-line",
                              dangerouslySetInnerHTML: {
                                __html: descriptionHtml
                              }
                            })
                      ]
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx("div", {
                                  children: $$Array.of_list(Belt_List.map(MultipleSelect$ReactHooksTemplate.nonEmptyChoices(multipleSelect), (function (choice) {
                                              return JsxRuntime.jsx(JsxRuntime.Fragment, {
                                                          children: Caml_option.some(JsxRuntime.jsx(MultipleSelectOptions$ReactHooksTemplate.make, {
                                                                    choice: choice,
                                                                    multipleSelect: multipleSelect,
                                                                    onChange: onChange,
                                                                    language: language,
                                                                    setErrorMessage: setErrorMessage,
                                                                    textInputClassName: " h-48-px py-2 px-4 bg-alicebluepurple border-b border-gray-500 focus:border-gray-600 text-xs w-full ",
                                                                    checkBoxInputClassName: " mb-2 ",
                                                                    checkboxClassName: " custom_checkbox ",
                                                                    containerClassName: " text-sm font-normal "
                                                                  }))
                                                        });
                                            }))),
                                  className: "pl-2"
                                }),
                            className: "flex flex-col"
                          }),
                      className: "flex w-full"
                    }),
                mandatory ? JsxRuntime.jsx(MandatoryMessage$ReactHooksTemplate.make, {
                        language: language
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                errorMessage !== undefined ? JsxRuntime.jsx("div", {
                        children: errorMessage,
                        className: "text-red-500 text-sm mt-1 text-left"
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ],
              className: "w-full px-16 small:px-6 " + props.borderCss
            });
}

var make = MultipleSelectDefaultForm;

exports.make = make;
/* react Not a pure module */
